//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "AppGrid",
	props: ["item"],
  computed: {}
};
